import React from 'react';
import PropTypes from 'prop-types';
import { Grid, GridCell } from 'v1/components/shared';
import styles from './ResourcePortalHeader.module.scss';
import { LanguageSwitcherWidget } from 'v5/features/core/LanguageSwitcherWidget.js';
import { myServices } from 'v5/services/services.connected.app.js';
import { useTranslation } from 'react-i18next';

const ResourcePortalHeader = ({
  companyName,
  teamName,
  imagePath = '',
  onOpenCalendarHint
}) => {
  const { t } = useTranslation('resource-portal');

  return (
    <header className={styles['ResourcePortalHeader']}>
      <Grid cellPadding="M">
        <GridCell>
          <Grid vcenter>
            {imagePath && (
              <img
                className={styles['ResourcePortalHeader__logo']}
                src={imagePath}
                alt=""
              />
            )}
            <h3>
              {companyName} - {teamName}
            </h3>
          </Grid>
        </GridCell>
        <GridCell width="auto" vcenter>
          <div className={styles['ResourcePortalHeader__actions']}>
            {onOpenCalendarHint && (
              <button
                aria-label={t('CalendarRoute.mobileHint.open')}
                className={styles['ResourcePortalHeader__helpButton']}
                onClick={onOpenCalendarHint}
                title={t('CalendarRoute.mobileHint.open')}
                type="button"
              >
                <img
                  alt=""
                  className={styles['ResourcePortalHeader__helpIcon']}
                  src="/images/icon_help_small.svg"
                />
              </button>
            )}
            <div className="tailwind-root contents">
              <LanguageSwitcherWidget
                services={myServices}
                className="float-right"
              />
            </div>
          </div>
          {/* <PressStud label="Create Account" isDisabled /> */}
        </GridCell>
      </Grid>
    </header>
  );
};

ResourcePortalHeader.propTypes = {
  imagePath: PropTypes.string,
  companyName: PropTypes.string,
  teamName: PropTypes.string,
  onOpenCalendarHint: PropTypes.func
};

export default ResourcePortalHeader;
